{
  "generic": "Tapahtui virhe",
  "networkError": "Verkkovirhe - tarkista yhteys",
  "unauthorized": "Sinulla ei ole oikeutta suorittaa tätä toimintoa",
  "notFound": "Pyydettyä resurssia ei löytynyt",
  "serverError": "Palvelinvirhe - yritä myöhemmin uudelleen",
  "validationError": "Tarkista syöttämäsi tiedot",
  "uploadFailed": "Lataus epäonnistui",
  "uploadSuccess_one": "{{count}} tiedosto ladattu onnistuneesti",
  "uploadSuccess_other": "{{count}} tiedostoa ladattu onnistuneesti",
  "invalidFileType": "Virheellinen tiedostotyyppi",
  "fileTooLarge": "Tiedosto on liian suuri",
  "sessionExpired": "Istuntosi on vanhentunut. Kirjaudu sisään uudelleen.",
  "loadAgentsFailed": "Agenttien lataaminen epäonnistui",
  "loadProfileFailed": "Käyttäjäprofiilin lataaminen epäonnistui",
  "stream": {
    "hitl_question_undelivered": "Emme pystyneet välittämään avustajan kysymystä. Missio voi olla edelleen käynnissä.",
    "subscription_forbidden": "Sinulla ei ole pääsyä tähän ajoon.",
    "subscription_unavailable": "Tämän ajon reaaliaikaiset päivitykset eivät ole juuri nyt saatavilla. Yritä uudelleen.",
    "control_forbidden": "Et voi ohjata tätä ajoa.",
    "control_unavailable": "Tätä ajoa ei voi juuri nyt pysäyttää, keskeyttää tai jatkaa. Yritä hetken kuluttua uudelleen.",
    "conversation_not_viewable": "Tämä keskustelu kuuluu toiselle henkilölle. Vain hän voi lukea sen täällä."
  }
}
